import { Method } from '../types';

const bin = [
  0.4, 0.9, 1.4, 1.9, 2.4, 2.9, 3.4, 3.9, 4.4, 4.9, 5.4, 5.9, 6.4, 6.9, 7.4, 7.9, 8.4,
  8.9, 9.4, 9.9, 10.4, 10.9, 11.4, 11.9, 12.4, 12.9, 13.4, 13.9, 14.4, 14.9, 15.4, 15.9,
  16.4, 16.9, 17.4, 17.9, 18.4, 18.9, 19.4, 19.9, 20.4,
];

const conzViabHistogram = ({
  deadCellCount,
  aliveCellCount,
}: {
  deadCellCount: number[];
  aliveCellCount: number[];
}) => {
  const hist = [];

  // each item of the bin corrospond to a cells in alive and dead cell array
  for (let i = 0; i < aliveCellCount.length; i++) {
    const _bin = bin[i];
    const _deadCellCount = deadCellCount[i];
    const _aliveCellCount = aliveCellCount[i];

    const maxCellCount =
      _aliveCellCount > _deadCellCount ? _aliveCellCount : _deadCellCount;

    if (_aliveCellCount || _deadCellCount) {
      const deadCellHist = [
        ...Array(_deadCellCount).fill(_bin),
        ...Array(maxCellCount - _deadCellCount).fill(null),
      ];

      const aliveCellHist = [
        ...Array(_aliveCellCount).fill(_bin),
        ...Array(maxCellCount - _aliveCellCount).fill(null),
      ];

      // merge both of the histograms and build a 2d array
      // here order of alive and dead histograms are important, since we pass 'alive' and 'dead' labels respectively
      for (let j = 0; j < maxCellCount; j++)
        hist.push([aliveCellHist[j], deadCellHist[j]]);
    }
  }
  return [['Alive', 'Dead'], ...hist];
};

const conzOnlyHistogram = ({ meanDia }: { meanDia: number[] }) => {
  const hist = [];

  // each item of the bin corrospond to a cells in alive and dead cell array
  for (let i = 0; i < meanDia.length; i++) {
    const _bin = bin[i];
    const _cellCount = meanDia[i];
    const total = Array(_cellCount).fill(_bin);
    for (let j = 0; j < total.length; j++) hist.push([total[j]]);
  }

  return [['Total'], ...hist];
};

export const histogramParser = ({
  dead,
  alive,
  meanDia,
  method,
}: {
  method: Method;
  dead: number[];
  alive: number[];
  meanDia: number[];
}) => {
  if (
    [Method.WineConzViab, Method.Yeast2ConzViab, Method.BioEthConzViab].includes(method)
  ) {
    return conzViabHistogram({
      deadCellCount: dead,
      aliveCellCount: alive,
    });
  }

  if ([Method.WineConz, Method.Yeast2Conz, Method.BioEthConz].includes(method)) {
    return conzOnlyHistogram({ meanDia });
  }
  return [];
};
